"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextDestination = void 0;
var tslib_1 = require("tslib");
var string_helper_1 = require("../../../../core/formats/utils/string-helper");
var string_1 = require("@devexpress/utils/lib/utils/string");
var destination_1 = require("../destination");
var TextDestination = (function (_super) {
    tslib_1.__extends(TextDestination, _super);
    function TextDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TextDestination.prototype, "elementHandlerTable", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    TextDestination.prototype.processText = function (reader) {
        var text = reader.value;
        text = this.replaceLineBreakOnSpace(text);
        if (!string_1.StringUtils.isNullOrEmpty(text)) {
            var plainText = string_helper_1.StringHelper.replaceParagraphMarksWithLineBreaks(text);
            if (!string_1.StringUtils.isNullOrEmpty(plainText))
                this.data.subDocumentInfo.characterImporter.insertText(plainText);
        }
        return true;
    };
    TextDestination.prototype.replaceLineBreakOnSpace = function (text) {
        return text.replace('\n', ' ');
    };
    return TextDestination;
}(destination_1.ElementDestination));
exports.TextDestination = TextDestination;
